import { Component, Input } from '@angular/core';
import { BaseControlComponent } from '../base-control/base-control.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { FieldLabelComponent } from '../../../ui/forms/field-label/field-label.component';
import { FieldErrorComponent } from '../../../ui/forms/field-error/field-error.component';

@Component({
	selector: 'app-number-control',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, FieldLabelComponent, FieldErrorComponent],
	templateUrl: './number-control.component.html',
	styleUrls: ['./number-control.component.scss'],
})
export class NumberControlComponent extends BaseControlComponent {
	@Input('min') public min: number | null = null;
	@Input('max') public max: number | null = null;

	ngOnInit() {}
}
